import React, { Component } from 'react'
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import TextField from 'material-ui/TextField';
import { brands } from 'data/actions';


class Dashboard extends Component {

  componentDidMount () {
    this.props.actions.fetchBrands();
  }
  
  render () {
    return (
      <div className="Dashboard">
        <h2 className="Dashboard_header">
          <span>Hej, </span>
          <span className="Dashboard_header_name">{this.props.user.displayName || this.props.user.email }</span>
          <spa>!</spa> 
        </h2>

        <div className="Dashboard_searchbox">
          <TextField
              style={{width: "100%"}}
              floatingLabelText="Var vill du annonsera?"
          />

        </div>

      </div>
    )
  }
}


function mapStateToProps(state) {
  return { 
  };
}
const mapDispatch = (dispatch) => {
    return {
        actions: bindActionCreators({...brands}, dispatch)
    };
}
export default connect(mapStateToProps, mapDispatch)(Dashboard)

  



// WEBPACK FOOTER //
// ./src/pages/Dashboard.jsx